import { observer } from 'mobx-react-lite';
import React from 'react';

import { company } from '~/company/Company';
import { Spinner } from '~/components/isolated/SpinnerWithLoadMore';
import ProductCard from '~/components/ProductCard/ProductCard';
import { Product } from '~/stores/CategoriesStore';

import styles from './SearchResultsContent.module.scss';

interface SearchResultsContentProps {
  searchResults: Product[] | null;
  onLoadMore?: () => void;
  canLoadMore?: boolean;
  isLoading?: boolean;
}

export const SearchResultsContent: React.FC<SearchResultsContentProps> =
  observer(({ searchResults, onLoadMore, canLoadMore, isLoading }) => {
    if (!searchResults || searchResults.length === 0) {
      return null;
    }

    return (
      <div className={styles.container}>
        <div data-company={company.name} className={styles.productsList}>
          {searchResults.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              className={styles.productCard}
              variant={company.productCardVariantL}
            />
          ))}
        </div>

        {canLoadMore && !isLoading && onLoadMore && (
          <Spinner onLoadMore={onLoadMore} />
        )}

        {isLoading && !canLoadMore && <Spinner />}
      </div>
    );
  });
